// Treść wiadomości jako tekst; klikalne są tylko linki do samochody.pl (inne zostają tekstem).
const OWN_LINK = /\bhttps?:\/\/(?:[a-z0-9-]+\.)*samochody\.pl(?:\/[^\s<]*)?/gi

export default function MessageText ({ text }) {
    const value = String(text || '')
    const out = []
    let last = 0
    for (const m of value.matchAll(OWN_LINK)) {
        const url = m[0].replace(/[.,!?)]+$/, '')
        if (m.index > last) out.push(value.slice(last, m.index))
        out.push(<a href={url} key={m.index} rel="noopener">{url}</a>)
        last = m.index + url.length
    }
    if (last < value.length) out.push(value.slice(last))
    return <>{out}</>
}
